import React from "react";
import DOMPurify from "dompurify";

// Language pick with cross-language fallback: an announcement may ship only
// one variant; showing the other language beats showing nothing.
export const pickLocalized = (dict, language) => {
    if (!dict)
        return '';
    const lang = (language || 'en').split('-')[0];
    return dict[lang] || dict[lang === 'tr' ? 'en' : 'tr'] || '';
};

// Single sanitized sink for admin-authored announcement HTML (Quill output).
// Every surface that renders body_html must go through this component.
const AnnouncementBody = ({html}) => (
    <div className="announcement-body"
         dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(html || '')}}/>
);

export default AnnouncementBody;
